
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import { configStore, uiStore } from "@/store/store-accessor";
import {
  DEFAULT_POPOUT_WIDTH,
  DEFAULT_OXYGEN_POPOUT_WIDTH
} from "@/lib/panels/panels";

@Component({
  components: { Dropdown }
})
export default class UnitCustomInputDropdown extends Vue {
  @Prop()
  value!: string;

  @Prop()
  disabled!: boolean;

  isDialogOpen = false;
  keepMaskOpenOnClose = false;

  get width() {
    return configStore.builderMode === "oxygen"
      ? DEFAULT_OXYGEN_POPOUT_WIDTH
      : DEFAULT_POPOUT_WIDTH;
  }

  @Watch("isDialogOpen")
  onDialogOpenChange() {
    if (this.disabled) return;

    if (this.isDialogOpen) {
      this.keepMaskOpenOnClose = uiStore.panelState.oxyPanelIsMasked;

      uiStore.setPanelState({
        ...uiStore.panelState,
        oxyPanelIsMasked: true
      });

      this.autofocus();
    } else {
      this.closeMask();
    }
  }

  autofocus() {
    setTimeout(() => {
      const input = this.$refs.input as HTMLTextAreaElement;
      input.focus();

      const value = input.value;
      if (value.endsWith(")")) {
        const pos = value.length - 1;
        input.setSelectionRange(pos, pos);
      }
    }, 100);
  }

  closeMask() {
    if (this.keepMaskOpenOnClose) {
      this.keepMaskOpenOnClose = false;
      return;
    }

    uiStore.setPanelState({
      ...uiStore.panelState,
      oxyPanelIsMasked: false
    });
  }
}
